import { Toaster } from "@tandemdiabetes/sugarmate-react-components"
import type { ReactNode } from "react"
import { StrictMode } from "react"

import { AuthContextProvider } from "./AuthContext"
import { DarkModeContextProvider } from "./DarkModeContext"
import { DbContextProvider } from "./DbContext"
import { LocalStorageContextProvider } from "./LocalStorageContext"
import { OverlayLoaderProvider } from "./OverlayLoaderContext"
import { PageLifecycleContextProvider } from "./PageLifecycleContext"
import { PolyglotProvider } from "./PolyglotContext"
import { SessionStorageContextProvider } from "./SessionStorageContext"
import { SWRContextProvider } from "./SWRContext"

interface Props {
  children: ReactNode;
}

// https://react.dev/reference/react/StrictMode#strictmode
// we don't include the db context as a child of strict mode because it will create duplicate db instantiation errors
export function AppContext(props: Props) {
  return (
    <PageLifecycleContextProvider>
      <SessionStorageContextProvider>
        <AuthContextProvider>
          <LocalStorageContextProvider>
            <SWRContextProvider>
              <DbContextProvider>
                <StrictMode>
                  <PolyglotProvider>
                    <DarkModeContextProvider>
                      <Toaster>
                        <OverlayLoaderProvider>
                          {props.children}
                        </OverlayLoaderProvider>
                      </Toaster>
                    </DarkModeContextProvider>
                  </PolyglotProvider>
                </StrictMode>
              </DbContextProvider>
            </SWRContextProvider>
          </LocalStorageContextProvider>
        </AuthContextProvider>
      </SessionStorageContextProvider>
    </PageLifecycleContextProvider>
  )
}
